var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnarchiveDarkicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.216,
    height: 19.216,
    viewBox: "0 0 19.216 19.216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_654",
    "data-name": "Union 654",
    d: "M-10344.51,2381.706a.7.7,0,0,1,0-.992l.839-.838a2.538,2.538,0,0,1-.1-.709v-12.7a2.445,2.445,0,0,1,2.578-2.285h12.854a2.907,2.907,0,0,1,.346.021l1.3-1.3a.7.7,0,0,1,.989,0,.7.7,0,0,1,0,.989l-.9.9,0,0-.825.823h0l-2.454,2.454h0l-1.155,1.155h0l-.932.932-.01.011-.241.241-.006,0-10.65,10.652-.029.03h0l-.618.618a.7.7,0,0,1-.494.2A.7.7,0,0,1-10344.51,2381.706Zm1.9-2.89,8.158-8.157h-2.116a1.254,1.254,0,0,1-.948-.441l-.82-.971a.068.068,0,0,0-.062-.029h-4.212Zm0-12.353v1.6h4.212a1.233,1.233,0,0,1,.947.436l.823.969a.076.076,0,0,0,.06.031h3.276l4.159-4.159h-12.06A1.291,1.291,0,0,0-10342.612,2366.464Zm1.418,15.273a2.619,2.619,0,0,1-.354-.023l1.133-1.132h12.074a1.414,1.414,0,0,0,1.41-1.415v-9.949h-2.121l1.155-1.155h.966v-.969l1.1-1.1a1.969,1.969,0,0,1,.057.472v12.7a2.574,2.574,0,0,1-2.57,2.57Zm5.935-6.314,1.161-1.16h1.983a.582.582,0,0,1,.584.576.584.584,0,0,1-.584.584Z",
    transform: "translate(10344.717 -2362.695)",
    fill: "#f8f8f8",
    opacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnarchiveDarkicon);
export default __webpack_public_path__ + "static/media/unarchive-darkicon.0db49b33e19dff827a206794d4ccd7da.svg";
export { ForwardRef as ReactComponent };